import { useMemo, useState } from 'react';
import { startOfDay } from '@budget/core';
import { useKioskBills } from '../../../data/useKioskBills';
import { useCalendarEvents } from '../../../data/useCalendarEvents';
import { MonthCalendar } from '../../../components/calendar/MonthCalendar';

// Kitchen kiosk's Bills widget. Reuses the shared MonthCalendar with the
// `tall` cell variant tuned for portrait orientation.
//
// Scope is intentionally locked to the household view: the kiosk shows the
// shared household calendar, not a per-person filtered one. (The web app's
// scope picker lives in the topbar, which the kiosk doesn't render.)

export function BillsWidget() {
  const { bills: loaded, isLoading, error } = useKioskBills();
  const { events } = useCalendarEvents();
  const today = useMemo(() => startOfDay(new Date()), []);
  const [cursorMonth, setCursorMonth] = useState(
    () => new Date(today.getFullYear(), today.getMonth(), 1),
  );

  if (error) {
    return <div className="text-red text-sm">{error}</div>;
  }
  if (isLoading) {
    return <div className="text-center py-12 text-fg-secondary">Loading…</div>;
  }
  const bills = loaded ?? [];
  if (bills.length === 0) {
    return <div className="empty-state">No bills in the sheet yet.</div>;
  }

  return (
    <MonthCalendar
      bills={bills}
      events={events}
      cursorMonth={cursorMonth}
      today={today}
      cellHeight="tall"
      showMonthlyTotal={false}
      disableLogoTooltips={true}
      onPrev={() =>
        setCursorMonth((m) => new Date(m.getFullYear(), m.getMonth() - 1, 1))
      }
      onNext={() =>
        setCursorMonth((m) => new Date(m.getFullYear(), m.getMonth() + 1, 1))
      }
      onToday={() =>
        setCursorMonth(new Date(today.getFullYear(), today.getMonth(), 1))
      }
      onSelectOccurrence={() => {
        // Kiosk does not surface a row-list to scroll to; the popover
        // itself is the detail view. No-op.
      }}
    />
  );
}
